export default __webpack_public_path__ + "static/post_4-8c10cdcffaad3461e06dde6db4334468.png";